export default {
  install(Vue) {
    Vue.mixin({
      methods: {
        getError (fieldName) {
          return this.errors.first(fieldName)
        }
      }
    })
  }
}
